// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { StoneColorTranslationFragmentDoc } from './StoneColorTranslation.fragment.generated';
export const StoneColorFragmentDoc = gql`
    fragment stoneColor on StoneColor {
  systemCode
  translation(locale: $locale) {
    ...stoneColorTranslation
  }
}
    ${StoneColorTranslationFragmentDoc}`;